/** @jsx jsx */
import React from "react";
import Downshift from "downshift";
import { Map } from "immutable";
import { CalendarIcon } from "./ui/icons/CalendarIcon";
import { DownChevronIcon } from "./ui/icons/DownChevronIcon";
import { RupeeIcon } from "./ui/icons/RupeeIcon";
import { SelectedCheckIcon } from "./ui/icons/SelectedCheckIcon";
import { StarIcon } from "./ui/icons/StarIcon";
import UrlQueryParamModifier from "./UrlQueryParamModifier";
import withUrlSortParam from "./withUrlSortParam";
// constants
import { CLEVERTAP_ACTIONS, DEFAULT_ELP_SORTER_VALUE, ELPSorters, EVENT_CATEGORIES, GA_ACTIONS, GENERAL_ACTIONS, HIT_TYPES } from "../helpers/constants";
import { sendClevertapEvent } from "../helpers/misc";
import { jsx, css } from "@emotion/core";
import { downshiftParent, selectField, selectFieldDropdown, selectFieldDropdownOption, selectFieldDropdownOptionContent, selectFieldDropdownOptionContentLeft, selectFieldInput, selectFieldParent, selectFieldParentContent, selectFieldParentHeader } from "../styles/toggleFilterStyles";
const getIconComponent = (icon, active) => {
    const iconStrToComponentMap = Map({
        date: <CalendarIcon active={active}/>,
        popularity: <StarIcon active={active}/>,
        price: <RupeeIcon active={active}/>
    });
    return iconStrToComponentMap.get(icon);
};
const SortSelectFieldItem = (props) => {
    const { getItemProps, highlightedIndex, index, isSelected, item } = props;
    const itemLabel = item.get("label");
    const itemValue = item.get("value");
    return (<a css={css(selectFieldDropdownOption)} highlighted={(highlightedIndex === index).toString()} selected={isSelected} {...getItemProps({
        key: itemLabel,
        index,
        item
    })}>
			<div css={css(selectFieldDropdownOptionContent(isSelected))}>
				<div css={css(selectFieldDropdownOptionContentLeft)}>
					<div className="icon-select-field-dropdown">{getIconComponent(itemValue, isSelected)}</div>
					{itemLabel}
				</div>
				{isSelected && (<div className="icon-select-field">
						<SelectedCheckIcon active={isSelected}/>
					</div>)}
			</div>
		</a>);
};
const SortSelectFieldInputBox = (props) => {
    const { getInputProps, getToggleButtonProps } = props;
    return (<button {...getToggleButtonProps()} css={css(selectField)}>
			<input type="button" readOnly={true} placeholder="Please select" {...getInputProps()} css={css(selectFieldInput)}/>
			<DownChevronIcon active={true}/>
		</button>);
};
function sendSorterClickedEvent(selection, source) {
    const selectedValue = selection.get("value", "");
    sendClevertapEvent(CLEVERTAP_ACTIONS.WEB_SORTER_CLICKED, {
        source: source,
        sorter: selectedValue
    });
    window.ga &&
        ga(GENERAL_ACTIONS.SEND, {
            hitType: HIT_TYPES.EVENT,
            eventCategory: EVENT_CATEGORIES.FILTER,
            eventAction: GA_ACTIONS.SORT_FILTER,
            eventLabel: selectedValue,
            eventValue: source
        });
}
class SortSelectField extends React.Component {
    render() {
        const options = this.props.ELPSorters || ELPSorters;
        const { selectedSorter = options.get(0), source } = this.props;
        return (<div css={css(selectFieldParent)}>
				<div css={css(selectFieldParentContent)}>
					<div css={css(selectFieldParentHeader)}>sort:</div>
					<UrlQueryParamModifier render={(props) => (<Downshift itemToString={item => (item ? item.get("label") : "")} initialSelectedItem={selectedSorter} onChange={(selection) => {
                    const selectedValue = selection.get("value");
                    sendSorterClickedEvent(selection, source);
                    if (selectedValue !== DEFAULT_ELP_SORTER_VALUE) {
                        props.onClick(Map({ sort: selection.get("value") }));
                    }
                    else {
                        // reset the sort query param
                        props.onClick(Map({ sort: undefined }));
                    }
                }}>
								{({ getInputProps, getItemProps, getMenuProps, getRootProps, getToggleButtonProps, highlightedIndex, isOpen, selectedItem = selectedSorter }) => (<div {...getRootProps()} css={css(downshiftParent(isOpen))}>
										{isOpen ? (<ul {...getMenuProps()} css={css(selectFieldDropdown)}>
												{options.map((item, index) => {
                            const isSelected = selectedItem === item;
                            return (<SortSelectFieldItem key={index} getItemProps={getItemProps} highlightedIndex={highlightedIndex} index={index} isSelected={isSelected} item={item}/>);
                        })}
											</ul>) : (<SortSelectFieldInputBox getInputProps={getInputProps} getToggleButtonProps={getToggleButtonProps}/>)}
									</div>)}
							</Downshift>)}/>
				</div>
			</div>);
    }
}
export default withUrlSortParam(SortSelectField);
